import { Reducer } from 'redux';
import { CurrentSubscription, SubscriptionPlan } from "models/SubscriptionPlan";
import { ISubscriptionActions, SubscriptionActionType } from "redux/actions/settings/SubscriptionActions";

export const currentSubscriptionReducer: Reducer<CurrentSubscription | null, ISubscriptionActions> =
    (state = null, action) => {
        switch (action.type) {
            case SubscriptionActionType.FETCH_CURRENTSUBSCRIPTION_SUCCESS:
                return action.returnPayload as CurrentSubscription;
            default:
                return state;
        }
    };

export const subscriptionPlansReducer: Reducer<SubscriptionPlan[] | null, ISubscriptionActions> =
    (state = null, action) => {
        switch (action.type) {
            case SubscriptionActionType.FETCH_SUBSCRIPTIONPLANS_SUCCESS:
                return action.returnPayload as SubscriptionPlan[];
            case SubscriptionActionType.EDIT_SUBSCRIPTIONPLAN_SUCCESS:
                {
                    const updated = action.returnPayload as SubscriptionPlan;
                    return state!.map(sp => sp.id === updated.id ? updated : sp);
                }
            default:
                return state;
        }
    };
